module.exports = __webpack_public_path__ + "img/google-earth-splash-2.1281a87a.jpg";